import $ from 'jquery';
import 'jquery.maskedinput/src/jquery.maskedinput';
// import MobCheck from '../js/mobile';
import Swiper from 'swiper/swiper-bundle.min';
import 'jquery.appear';
import 'slick-carousel';
import '../js/jquery-ui.min.js';
import '../js/gsap.min.js';
import '../js/ScrollSmoother.min.js';
import '../js/ScrollToPlugin.min.js';
import '../js/ScrollTrigger.min.js';
import videojs from 'video.js';
import Reflect from 'core-js/fn/reflect';

// import { Scrollbar, EffectCreative } from "swiper";

window.$ = window.jQuery = $;
window.isDev = window.location.host === 'localhost:8080';

const searchParam  =   Object.fromEntries(new URLSearchParams(window.location.search));
const utmFlats = Object.hasOwn(searchParam, 'utm_content') && searchParam.utm_content === 'flats'

//touch punch
!(function (a) {
  function f(a, b) {
    if (!(a.originalEvent.touches.length > 1)) {
      a.preventDefault();
      var c = a.originalEvent.changedTouches[0],
        d = document.createEvent('MouseEvents');
      d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d);
    }
  }
  if (((a.support.touch = 'ontouchend' in document), a.support.touch)) {
    var e,
      b = a.ui.mouse.prototype,
      c = b._mouseInit,
      d = b._mouseDestroy;
    (b._touchStart = function (a) {
      var b = this;
      !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && ((e = !0), (b._touchMoved = !1), f(a, 'mouseover'), f(a, 'mousemove'), f(a, 'mousedown'));
    }),
      (b._touchMove = function (a) {
        e && ((this._touchMoved = !0), f(a, 'mousemove'));
      }),
      (b._touchEnd = function (a) {
        e && (f(a, 'mouseup'), f(a, 'mouseout'), this._touchMoved || f(a, 'click'), (e = !1));
      }),
      (b._mouseInit = function () {
        var b = this;
        b.element.bind({ touchstart: a.proxy(b, '_touchStart'), touchmove: a.proxy(b, '_touchMove'), touchend: a.proxy(b, '_touchEnd') }), c.call(b);
      }),
      (b._mouseDestroy = function () {
        var b = this;
        b.element.unbind({ touchstart: a.proxy(b, '_touchStart'), touchmove: a.proxy(b, '_touchMove'), touchend: a.proxy(b, '_touchEnd') }), d.call(b);
      });
  }
})(jQuery);
//touch punch

const popupStack = {
  _ps: [],
  push(v) {
    // FIX: fix scroll issue @mobile
    this._ps.push(v);
    Site.smoother?.paused(true);
    switch (v) {
      case '#popup_mortgage':
        captureWheelEvent();
        break;
    }
  },
  pop() {
    this._ps.pop();
    if (!this._ps.length) {
      Site.smoother?.paused(false);
      $(document.body).removeClass('lock');
      window._captureWheeEventController = window._captureWheeEventController?.abort();
    }
  },
};

function captureWheelEvent() {
  if (!window._captureWheeEventController) window._captureWheeEventController = new AbortController();
  const handler = (e) => {
    let node = e.target;
    while (node && node.scrollHeight <= node.clientHeight) node = node.parentNode;
    node && node !== document.body && node !== document.documentElement && e.stopPropagation();
  };

  document.addEventListener('wheel', handler, {
    passive: true,
    capture: true,
    signal: window._captureWheeEventController?.signal,
  });
}

function showCallMePoup(id = '#popup_request') {
  $.fancybox.open($(id), fancy_option_line);

  popupStack.push(id);

  $('.form .form-error-message').hide();
  $('.form .form__input').removeClass('error');
  $('.form form').show();
  $('.form input').val('');
  // $('.p_request .popup__title').html(`
  //           обратная связь
  //           <div>Заполните заявку и&nbsp;мы свяжемся с&nbsp;вами в&nbsp;ближайшее&nbsp;время</div>
  //         `);
}

function showMortgagePopup() {
  const popup = $('#popup_mortgage');
  if (!popup.length) return;
  popupStack.push('#popup_mortgage');

  popup.addClass('active');
}

window.fancy_option_line = {
  type: 'inline',
  touch: false,
  hideScrollbar: true,
  animationEffect: 'zoom-in-out',
  animationDuration: 500,
  clickOutside: 'close',
  hash: false,
  afterShow: function () {},
};

var LazyLoad = {
  src: function (el) {
    if (Site.isMobile && el.dataset.lazyMobile) {
      return el.dataset.lazyMobile;
    }
    return el.dataset.lazy;
  },
  init: function () {
    var elements = document.querySelectorAll('[data-lazy]');
    elements.forEach((el) => {
      if (el.getBoundingClientRect().top <= window.innerHeight) {
        if (!el.classList.value.includes('lazy-loaded')) {
          el.classList.add('lazy-loaded');

          const src = LazyLoad.src(el);
          if (el.tagName === 'IMG') {
            el.src = src;
          } else {
            el.style.backgroundImage = `url('${src}')`;
          }
        }
      }
    });
  },
};

class Main {
  Init = () => {
    $('.pano-lock').on('click', ({ target }) => {
      target = $(target);
      const iframe = target.closest('.pano-iframe');
      iframe?.toggleClass('-unlock', !iframe.hasClass('-unlock'));
    });

    $('.sec7 .btn').click(function (e) {
      e.preventDefault();
      $('.popup-pano').addClass('active');
    });

    $('.popup-pano .popup-images__close').click(function () {
      $('.popup-pano').removeClass('active');
    });

    $(document).keyup(function (e) {
      if (e.key === 'Escape') {
        $('.popup.p_request .popup_close').trigger('click');
      }
    });

    $('.popup-mortgage__close').on('click', () => {
      popupStack.pop();
      $('#popup_mortgage').removeClass('active');
    });

    Site.init();

    Calc.init();

    Gallery.init();

    Adv.start();

    Team.start();

    PopupMedia.init();

    Cookie.init();

    Payment.init();

    Overview.init();

    Map.load();

    const self = this;

    // const searchParam  =   Object.fromEntries(new URLSearchParams(window.location.search));
    // const utmFlats = Object.hasOwn(searchParam, 'utm_content') && searchParam.utm_content === 'flats'

    /*let padY = 0;
    $('.appear').appear(function () {
        $(this).addClass('anim');
    }, {accX: 0, accY: padY});*/

    $('html, body').animate(
      {
        scrollTop: 0,
      },
      0,
    );
    window.scrollTo(0, 0);
    $(document).ready(function () {
      setTimeout(function () {
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          0,
        );
        window.scrollTo(0, 0);
      }, 1);

      $(".flats-btn, #go-to-flats").click(function(){
        const isVisible = $("#flats").is(':visible');
        if (isVisible) {
          $('.flats-btn').html('<span>выбрать квартиру</span>')
        } else {
          $('.flats-btn').html('<span>скрыть квартиры</span>')

          if (Site.isMobile) {

          } else {
            setTimeout(() => {
              Site.smoother.scrollTo('#flats', true);
            }, 100)
          }

        }

        if (!utmFlats) {
          // $("#flats").toggle();
        }


        if (Site.isMobile) {
          $('#flats')[0].scrollIntoView();
        } else {
          window.advSectionTl1.scrollTrigger.refresh()
          window.advSectionTl2.scrollTrigger.refresh()
          window.advSectionTl3.scrollTrigger.refresh()
          window.teamSectionTl1.scrollTrigger.refresh()
          window.teamSectionTl2.scrollTrigger.refresh()
          window.teamSectionTl3.scrollTrigger.refresh()
        }

      });

      $('[data-scroll-button]').on('click', function () {
        const dir = $(this).data('scroll-button')
        if (dir === 'up') {
          Site.smoother.scrollTo(0, true);
        } else {
          Site.smoother.scrollTo('.s_contacts', true);
        }
      })

      $('[data-map-locker]').on('click', function () {
        const className = '-unlock'

        $(this).toggleClass(className);

        if ($(this).hasClass(className)) {
          $(this).html('<span>Заблокировать карту</span>')
          $('#map').addClass(className)
        } else {
          $(this).html('<span>Разблокировать карту</span>')
          $('#map').removeClass(className)
        }
      })
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    self.MobClass();
    $(window).on('resize', function () {
      self.MobClass();
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    $(window.visualViewport).on('resize', function () {
      self.MobClass();
      let vh = window.visualViewport.height * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if ($('.s_top').length) {
      self.TopSlider();
    }
    if ($('.slider-loc2').length) {
      self.SliderLoc();
    }
    if ($('#sec-8-cont').length) {
      //self.Sec8Slider();
    }
    if ($('.sec12-flat-wrap').length) {
      setTimeout(function () {
        self.FlatsSlider();
      }, 1000);
    }
    if ($('.sale_block').length) {
      self.SaleSlider();
    }
    if ($('.s_din').length) {
      self.BlockDinamic();
    }
    if ($('.s_about_slider').length) {
      self.AboutSlider();
    }

    if ($('.sec-10-mobslider').length) {
      self.GallerySlider();
    }

    if ($('.sec2__videoWrap video').length) {
      let videoNode = window.document.querySelector('.sec2__videoWrap video');
      let timeNode = window.document.querySelector('.js-video-time');
      videoNode.addEventListener('loadedmetadata', function (e) {
        let duration = videoNode.duration.toFixed(1);
        let m = Math.floor(duration % 60);
        timeNode.innerText = Math.floor(duration / 60) + ':' + (m < 10 ? '0' : '') + m;
      });
    }

    $('.sec2__videoWrap').on('click', function () {
      $(this).addClass('active');
      let video = $(this).find('video')[0];
      if (video.paused === true) {
        video.play();
      } else {
        video.pause();
      }
    });

    $('.loc_tab').on('click', function () {
      let id = $(this).attr('data-id');
      $('.loc_tab').removeClass('active');
      $(this).addClass('active');
      $('.loc_tab__content:visible').hide();
      $('.loc_tab__content[data-id=' + id + ']').fadeIn(700);
    });

    $('.anchor').on('click', function (e) {
      e.preventDefault();
      let href = $(this).attr('href');
      if (!href) href = $(this).attr('data-href');
      if ($(href).length) {
        if (Site.smoother) {
          //Site.smoother.scrollTo($(href).offset().top, false)
          Site.smoother.scrollTo(href, true);
          //$("html, body").animate({ scrollTop: $(href).offset().top }, 0);
        } else {
          $('html, body').animate({ scrollTop: $(href).offset().top }, 0);
        }
      }
    });

    document.addEventListener('click', function (e) {
      let t = $(e.target);
      if (t.closest('.s_din__select').length === 0) {
        $('.s_din__select__val').removeClass('active');
      }
    });

    $('.popup_show').on('click', function (e) {
      e.preventDefault();

      let id = $(this).attr('href');
      if (!id) id = $(this).attr('data-href');
      if (!id) return false;

      if ($(this).hasClass('popup-img')) {
        $(id)
          .find('img:not(.init)')
          .each(function () {
            $(this).attr('src', $(this).attr('data-src'));
            $(this).addClass('init');
          });
      }

      if ($(id).find('iframe').length && !$(id).hasClass('loaded')) {
        $('body').addClass('wait');
        $(id).addClass('loading');
        //return false;
        setTimeout(function () {
          $(id).removeClass('loading');
          $.fancybox.open($(id), fancy_option_line);
          $('body').removeClass('wait');
          $(id).addClass('loaded');
        }, 1000);
      } else {
        showCallMePoup(id);
      }
      return false;
    });

    $('.popup_close').on('click', function (e) {
      popupStack.pop();
    });

    $('form .phone input').mask('+7(999) 999-9999', {
      autoclear: true,
      completed: function () {
        validateInput($(this));
      },
    });

    function getFormData(f) {
      let unindexed_array = f.serializeArray();
      let indexed_array = {};
      $.map(unindexed_array, function (n, i) {
        let name = n['name'];
        let value = n['value'];
        if (name.indexOf('[]') != -1) {
          if (!indexed_array[name]) {
            indexed_array[name] = [];
          }
          indexed_array[name].push(value);
        } else {
          indexed_array[name] = value;
        }
      });
      return indexed_array;
    }

    function validateEmail(email) {
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function validateForm(form) {
      let check = true;
      let block_error = form.find('.form-error-message');

      form.find('.req:visible').each(function () {
        if (
          $(this).find('input').val() === '' &&
          $(this).parent('.form__block-file').length &&
          $(this).parent('.form__block-file').find('.form-file-list').html().replace(/\s/g, '') !== ''
        ) {
          return;
        }

        if ($(this).find('input').val() === '') {
          $(this).addClass('error');
          check = false;
        } else if ($(this).find('input[type=checkbox]').length && !$(this).find('input:checked').length) {
          $(this).addClass('error');
          check = false;
        } else if ($(this).find('textarea').val() === '') {
          $(this).addClass('error');
          check = false;
        } else {
          if (
            ($(this).find('input').length && $(this).find('input').val().replace(/\s/g, '') === '') ||
            ($(this).find('textarea').length && $(this).find('textarea').val().replace(/\s/g, '') === '')
          ) {
            $(this).addClass('error');
            check = false;
          } else {
            $(this).removeClass('error');
          }
        }
      });

      if (!check) {
        block_error.html(block_error.html() + block_error.attr('data-mess-empty') + '<br>');
        block_error.slideDown();
      }

      form.find('.email').each(function () {
        if ($(this).hasClass('req') || $(this).find('input').val().length) {
          if (!validateEmail($(this).find('input').val().replace(/\s/g, ''))) {
            $(this).addClass('error');
            if ($(this).hasClass('edited')) {
              $(this).find('[data-mess-email]').slideDown();
            }

            check = false;
          } else {
            $(this).removeClass('error');
          }
        } else {
          $(this).removeClass('error');
        }
      });

      return check;
    }

    function validateInput(input_in) {
      let parent = input_in.parent('.form__input');
      if (parent.hasClass('error')) {
        if (parent.hasClass('req') && input_in.val() !== '') {
          if (parent.hasClass('email')) {
            if (validateEmail(input_in.val())) {
              parent.removeClass('error');
            }
          } else {
            parent.removeClass('error');
          }
        }
      }
    }

    $('.form form').bind('submit', function (e, url_custom) {
      e.preventDefault();

      let f = $(this);
      let url = f.attr('action');
      let block_error = f.find('.form-error-message');
      if (url_custom) {
        url = url_custom;
      }

      block_error.slideUp();
      block_error.html('');
      $('.form__input__mess').slideUp();

      if (!validateForm(f)) {
        e.preventDefault();
        f.find('.error').eq(0).find('input').focus();
        return false;
      }

      if (!f.find('input[name="asc"]').length) {
        f.append('<input hidden type="text" name="asc" value="' + $('body').attr('data-rel') + '">');
      }
      let data = getFormData(f);

      console.log(data);
      self.WaitOn();
      let formData = new FormData(f.get(0));

      // Обработка чекбокса
      formData.delete('agree');
      const checkbox = f.find('input[type=checkbox]');
      if (checkbox.length) {
        checkbox.each((idx, el) => {
          formData.append($(el).attr('name'), $(el).is(':checked'));
        })
      }
      //

      // Calltouch
      // const fio = document.querySelector("#user_name").value || null;
      const phoneNumber = document.querySelector('#user_phone').value || null;
      const calltouchPhone = phoneNumber.replaceAll(/[^0-9+]/g, '').replaceAll('+', '');

      if (window?.ctw) {
        window.ctw.createRequest('64600', calltouchPhone, [], (success, data) => {
          console.log(success, data);
        });
      }

      $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        contentType: false,
        processData: false,

        success: function (response) {
          console.log(response);
          self.WaitOff();

          if (response.error) {
            block_error.html(response.message);
            block_error.slideDown();
            /*
                                }else if(response.success) {
                                    //location.href = response.url;
                                    f.parents('.popup').find('.popup__title').html(block_error.attr('data-success-title')+'<div>'+block_error.attr('data-success-text')+'</div>');
                                    f.hide();
            */
          } else {
            //block_error.html(block_error.attr('data-mess'));
            //block_error.slideDown();
            f.parents('.popup')
              .find('.popup__title')
              .html(block_error.attr('data-success-title') + '<div>' + block_error.attr('data-success-text') + '</div>');
            f.hide();
          }
        },
        error: function (response) {
          console.log(response);
          self.WaitOff();
          block_error.html(block_error.attr('data-mess'));
          block_error.slideDown();
        },
      });

      return false;
    });


    if (utmFlats) {
      $('.s_top__imgs._utm').addClass('_show')
      // $('.s_top__item.video').show().addClass('active')
      // $('.s_top__item.image').hide().removeClass('active')

      $('.flats-btn').addClass('-hide');
      $("#flats").show();
      window.advSectionTl1.scrollTrigger.refresh()
      window.advSectionTl2.scrollTrigger.refresh()
      window.advSectionTl3.scrollTrigger.refresh()
      window.teamSectionTl1.scrollTrigger.refresh()
      window.teamSectionTl2.scrollTrigger.refresh()
      window.teamSectionTl3.scrollTrigger.refresh()
    } else {
      $('.s_top__imgs:not(._utm)').addClass('_show')
      // $('.s_top__item.video').hide().removeClass('active')
      // $('.s_top__item.image').show().addClass('active')
    }
  }

  TopSlider = () => {
    function slideMediaAwait(idx = 0) {
      const slide = $('.s_top__item').eq(idx);
      return new Promise((resolve, reject) => {
        let fsMedia = slide.find('.-img, video');
        const tagName = fsMedia.prop('tagName');
        if (tagName === 'DIV') {
          let tmpImg = new Image();
          let tmpImgSrc = fsMedia.css('background-image');
          tmpImgSrc = tmpImgSrc.replaceAll('url("', '').replaceAll('")', '');
          tmpImg.src = tmpImgSrc;
          fsMedia = $(tmpImg);
        }
        if (fsMedia.prop('readyState') > 1 || fsMedia.complete) {
          resolve();
        } else {
          fsMedia.on('loadedmetadata load', () => {
            resolve();
          });
          fsMedia.one('error', () => {
            reject();
          });
        }
      });
    }
    let sl_top = new Swiper('.slider-top', {
      slidesPerView: '1',
      speed: 1000,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      navigation: {
        nextEl: '.slider-top .sl_arrs .-r',
        prevEl: '.slider-top .sl_arrs .-l',
      },
      on: {
        init: async function (swiper) {
          await slideMediaAwait();
          $('body').addClass('load');
          // $('.s_top__item').eq(0).addClass('active');
          if (!swiper.isLocked) {
            $('.slider-top').addClass('disable');
          }
          setTimeout(function () {
            $('.slider-top').addClass('anim_active');
          }, 1000);
          $('.sl_arr__sep').removeClass('stop');
        },
        slideChange: function (swiper) {
          stop_anim_line();
          // $('.s_top__item').removeClass('active');
          // $('.s_top__item').eq(swiper.realIndex).addClass('active');
        },
        touchStart: function () {
          //$('.sl_arr__sep').addClass('stop');
        },
        touchEnd: function () {
          //$('.sl_arr__sep').removeClass('stop');
        },
      },
    });

    function stop_anim_line() {
      const slider_arr__sep = $('.sl_arr__sep');
      slider_arr__sep.addClass('stop');
      setTimeout(function () {
        slider_arr__sep.removeClass('stop');
      }, 1000);
    }
  };

  SliderLoc = () => {
    const progressCircle = document.querySelector('.swiper-hero-progress');

    Main.swiper3 = new Swiper('.slider-loc2', {
      loop: true,
      speed: 1000,
      effect: 'creative',
      /*autoplay: {
          delay: 3000,
          disableOnInteraction: true,
      },*/
      //allowTouchMove: false,

      watchSlidesProgress: true,
      creativeEffect: {
        prev: {
          translate: [0, 0, -400],
          opacity: 1,
        },
        next: {
          translate: ['100%', 0, 0],
          opacity: 0,
        },
      },
      navigation: {
        nextEl: '.sec7 .arrow-next',
        prevEl: '.sec7 .arrow-prev',
      },
      on: {
        init: function (s) {
          $('.swiper-progress-anim').removeClass('anim');
          setTimeout(function () {
            $('.swiper-progress-anim').addClass('animStart');
          }, 1);
        },
      },
    });

    Main.swiper3.on('slideChange', function (swiper) {
      $('.sec7 .swiper-progress-anim').removeClass('animStart');
      $('.sec7 .swiper-progress-anim').removeClass('anim');
      setTimeout(function () {
        $('.swiper-progress-anim').addClass('anim');
      }, 2);
      Main.swiper2.slideTo(swiper.realIndex);
    });

    Main.swiper2 = new Swiper('.slider-loc', {
      loop: true,
      effect: 'creative',
      direction: 'vertical',
      speed: 1000,

      allowTouchMove: false,
      creativeEffect: {
        prev: {
          translate: [0, '0%', -1],
        },
        next: {
          translate: [0, '100%', 0],
        },
      },
      pagination: {
        el: '.navi-counter',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.sec7 .arrow-next',
        prevEl: '.sec7 .arrow-prev',
      },
    });
    //swiper2.controller.control = swiper3;
    //swiper3.controller.control = swiper2;
  };

  FlatsSlider = () => {
    let tab_hover_time;
    $('.sec12-tabs div').hover(
      function () {
        if (tab_hover_time) clearTimeout(tab_hover_time);
        $('.sec12-tabs div').removeClass('hover');
        $(this).addClass('hover');
      },
      function () {
        tab_hover_time = setTimeout(function () {
          $('.sec12-tabs div').removeClass('hover');
        }, 300);
      },
    );

    $('.sec12').append('<div class="js-slider-flat1" style="display: none"></div><div class="js-slider-flat2" style="display: none"></div>');
    $('.js-slider-flat1').html($('.slider-flat1 .swiper-wrapper').html());
    $('.js-slider-flat2').html($('.slider-flat2 .swiper-wrapper').html());
    $('.sec12-tabs div').click(function () {
      $(this).toggleClass('active').siblings().removeClass('active');
      let id = [];
      //let sliders_flat = $('.slider-flat1 .swiper-slide');
      //let sliders_plans = $('.slider-flat2 .swiper-slide');
      $('.sec12-tabs div.active').each(function () {
        id.push($(this).attr('data-id'));
      });
      //sliders_flat.addClass('none');
      //sliders_plans.addClass('none');
      let sliders_flat_html = '';
      let sliders_plans = '';
      $('.js-flats-navi').removeClass('none');

      if (id.length) {
        id.forEach((el) => {
          $('.js-slider-flat1 .swiper-slide[data-id="' + el + '"]').each(function () {
            sliders_flat_html += $(this)[0].outerHTML;
          });
          $('.js-slider-flat2 .swiper-slide[data-id="' + el + '"]').each(function () {
            sliders_plans += $(this)[0].outerHTML;
          });
        });
        $('.slider-flat1 .swiper-wrapper').html(sliders_flat_html);
        $('.slider-flat2 .swiper-wrapper').html(sliders_plans);
        if (!sliders_flat_html) {
          $('.js-flats-navi').addClass('none');
        }
      } else {
        //sliders_flat.removeClass('none');
        //sliders_plans.removeClass('none');
        $('.slider-flat1 .swiper-wrapper').html($('.js-slider-flat1').html());
        $('.slider-flat2 .swiper-wrapper').html($('.js-slider-flat2').html());
      }

      swiperFlat1.update();
      swiperFlat2.update();
      swiperFlat1.slideTo(0);
      swiperFlat2.slideTo(0);

      $('.sec12-flat-wrap .btn').click(function () {
        $('header .popup_show').trigger('click');
      });
    });

    let navi_line_flats = $('.js-flats-navi .swiper-progress-anim');

    let swiperFlat1 = new Swiper('.slider-flat1', {
      navigation: {
        nextEl: '.js-flats-navi .arrow-next',
        prevEl: '.js-flats-navi .arrow-prev',
      },
      speed: 1000,
      //autoHeight: true,
      autoplay: false,
      pagination: {
        el: '.flats-navi-counter',
        type: 'fraction',
      },
      on: {
        init: function () {
          $('.sec12-flat-wrap .swiper-progress-anim').removeClass('anim');
          setTimeout(function () {
            $('.sec12-flat-wrap .swiper-progress-anim').addClass('animStart');
          }, 1);

          this.el.addEventListener('mouseenter', () => {
            this.autoplay.stop();
            navi_line_flats.addClass('pause');
            navi_line_flats.removeClass('animStart');
            navi_line_flats.removeClass('anim');
          });

          this.el.addEventListener('mouseleave', () => {
            this.autoplay.start();
            navi_line_flats.removeClass('pause');
            navi_line_flats.addClass('animStart');
          });
        },
      },
      ldirection: 'horizontal',
      breakpoints: {
        1000: {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            stopOnLastSlide: true,
          },
        },
      },
    });

    swiperFlat1.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 2);
    });

    let swiperFlat2 = new Swiper('.slider-flat2', {
      loop: false,
      ldirection: 'horizontal',
    });

    swiperFlat2.controller.control = swiperFlat1;
    swiperFlat1.controller.control = swiperFlat2;
  };

  GallerySlider = () => {
    Site.galleryslider = new Swiper('.sec-10-mobslider__images .swiper', {
      slidesPerView: 'auto',
      allowTouchMove: true,
      navigation: {
        nextEl: '.gallery-navi .arrow-next',
        prevEl: '.gallery-navi .arrow-prev',
      },
      speed: 1000,
      loop: false,
      loopedSlides: 7,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.gallery-navi-counter',
        type: 'fraction',
      },
      on: {
        init: function () {
          this.autoplay.stop();
        },
        slideChange: function (swiper) {
          let gtindex = swiper.activeIndex;
          $('.sec-10-mobslider__title').removeClass('active');
          $('.sec-10-mobslider__title:eq(' + gtindex + ')').addClass('active');
          let gtshift = 0;
          for (var i = 0; i < gtindex; i++) {
            gtshift -= $('.sec-10-mobslider__title:eq(' + i + ')').outerWidth();
          }
          $('.sec-10-mobslider__titles').css('transform', 'translateX(' + gtshift + 'px)');
        },
      },
    });
  };

  SaleSlider = () => {
    let navi_line_flats = $('.js-slider-sale .swiper-progress-anim');

    let slider = new Swiper('.sale_block .swiper', {
      navigation: {
        nextEl: '.js-slider-sale .arrow-next',
        prevEl: '.js-slider-sale .arrow-prev',
      },
      slidesPerView: 3,
      spaceBetween: 40,
      speed: 1000,
      loop: false,
      watchOverflow: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          navi_line_flats.removeClass('anim');
          setTimeout(function () {
            navi_line_flats.addClass('animStart');
          }, 1);

          this.el.addEventListener('mouseenter', () => {
            this.autoplay.stop();
            navi_line_flats.addClass('pause');
            navi_line_flats.removeClass('animStart');
            navi_line_flats.removeClass('anim');
          });

          this.el.addEventListener('mouseleave', () => {
            this.autoplay.start();
            navi_line_flats.removeClass('pause');
            navi_line_flats.addClass('animStart');
          });
        },
      },
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
        1001: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          spaceBetween: 40,
        },
      },
    });

    slider.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 2);
    });
  };

  MobClass = () => {
    $('body').toggleClass('hover', !('ontouchstart' in window || navigator.maxTouchPoints > 0));
  };

  BlockDinamic = () => {
    $('.s_din').append('<div class="js-din__slider" style="display: none"></div>');
    $('.js-din__slider').html($('.s_din__slider .swiper-wrapper').html());

    function init_dinamic() {
      if ($('.s_din__select li').length <= 1) {
        $('.s_din__select').hide();
      }

      let year = $('.s_din__select__list li.active').text();
      let type = $('.s_din__tab.active').attr('data-type');

      let html_din_slider = '';
      $('.js-slider-din-navi').removeClass('none');

      // $('.js-din__slider .swiper-slide[data-type="' + type + '"][data-year="' + year + '"]')
      $('.js-din__slider .swiper-slide[data-type="' + type + '"]').each(function () {
        html_din_slider += $(this)[0].outerHTML;
      });
      $('.s_din__slider .swiper-wrapper').html(html_din_slider);
      if (!html_din_slider) {
        $('.js-slider-din-navi').addClass('none');
      }

      if (Site.dinSlider) {
        Site.dinSlider.update();
        Site.dinSlider.slideTo(0);
        PopupMedia.init();
      }
    }

    init_dinamic();
    $('.s_din__tab').click(function () {
      $('.s_din__tab').removeClass('active');
      $(this).toggleClass('active');
      init_dinamic();
    });

    $('.s_din__select__val').bind('click', function () {
      $(this).toggleClass('active');
    });

    $('.s_din__select__list li').bind('click', function () {
      let din_list = $('.s_din__select__val');
      $('.s_din__select__list li').removeClass('active');
      $(this).addClass('active');
      din_list.removeClass('active');
      din_list.text($(this).text());
      init_dinamic();
    });

    let navi_line_flats = $('.js-slider-din-navi .swiper-progress-anim');

    Site.dinSlider = new Swiper('.s_din__slider .swiper', {
      navigation: {
        nextEl: '.s_din__slider .arrow-next',
        prevEl: '.s_din__slider .arrow-prev',
      },
      speed: 1000,
      slidesPerView: 1.108,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          this.autoplay.stop();
          navi_line_flats.removeClass('anim');
          setTimeout(function () {
            navi_line_flats.addClass('animStart');
          }, 1);

          PopupMedia.init();
        },
      },
      breakpoints: {
        1000: {
          slidesPerView: 3,
        },
      },
    });

    Site.dinSlider.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 2);
    });

    window.gsap.to('.s_din__slider', {
      scrollTrigger: {
        trigger: '.s_din__slider',
        start: 'top +=50%',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function (s) {
          if (Site.dinSlider) {
            Site.dinSlider.autoplay.start();
          }
        },
        onLeave: function () {
          if (Site.dinSlider) {
            Site.dinSlider.slideTo(0)
            Site.dinSlider.autoplay.stop();
          }
        },
      },
    });

  };

  AboutSlider = () => {
    let navi_line_flats = $('.js-about_slider_navi .swiper-progress-anim');

    let slider = new Swiper('.s_about_slider .swiper', {
      navigation: {
        nextEl: '.s_about_slider .arrow-next',
        prevEl: '.s_about_slider .arrow-prev',
      },
      speed: 1000,
      slidesPerView: 'auto',
      spaceBetween: 24,
      //loop: true,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      // },
      on: {
        init: function () {
          navi_line_flats.removeClass('anim');
          setTimeout(function () {
            navi_line_flats.addClass('animStart');
          }, 1);
        },
      },
      breakpoints: {
        1000: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
    });

    // slider.on('slideChange', function () {
    //   navi_line_flats.removeClass('animStart');
    //   navi_line_flats.removeClass('anim');
    //   setTimeout(function () {
    //     navi_line_flats.addClass('anim');
    //   }, 1);
    // });
  };

  WaitOn = () => {
    $('body').addClass('wait');
  };

  WaitOff = () => {
    $('body').removeClass('wait');
  };
}

const Map = {
  load() {
    const script = document.createElement('script');
    script.src = "https://api-maps.yandex.ru/2.1/?apikey=e23d542b-feac-4115-b0b7-384d173eb383&suggest_apikey=737dd575-86f6-4ee4-a14e-1710c8832954&lang=ru_RU";
    script.async = true;
    script.onload = () => {
      ymaps.ready(() => {
        this.contactsMapInit();
        this.popupMapInit();
      });
    };
    document.head.appendChild(script);
  },

  contactsMapInit(){
    this.init('.s_contacts__map', 'map', '/src/img/marker.svg');
  },

  popupMapInit(){
    $('.open-map').on('click', function () {
      $('.popup-map[data-type="map"]').addClass('active');
      popupStack.push('map');
    });

    $('.popup-map[data-type="map"] .popup-map__close').on('click', function () {
      popupStack.pop();
      $('.popup-map[data-type="map"]').removeClass('active');
    });

    this.init('.popup-map', 'popupMap', '/src/img/marker_mob.svg');
  },

  init(mapContainer, mapId, markerIcon) {
    if (typeof ymaps === 'undefined') return false;

    const latlng = document.getElementById(mapId).getAttribute('data-coords').split(',');
    ymaps.ready(() => {
      const inputField = $(mapContainer).find('.route__text').get(0);
      new ymaps.SuggestView(inputField);
      const $buildRouteButton = $(mapContainer).find('.route__btn');
      const $actionRoutesButton = $(mapContainer).find('.route__action-btn');
      const $routeTabs = $(mapContainer).find('.route__tab');
      const $routeTabsContainer = $(mapContainer).find('.route__tabs');
      const $zoomPlus = $(mapContainer).find('._plus');
      const $zoomMinus = $(mapContainer).find('._minus');

      let selectedMode = "driving";
      let currentRoutes = {};

      $routeTabsContainer.css('display', 'none');
      $actionRoutesButton.addClass('_active');

      const map = new ymaps.Map(mapId, {
        center: latlng,
        zoom: 15,
        controls: [],
      });
      map.behaviors.disable(['scrollZoom']);

      const marker = new ymaps.Placemark(latlng, {}, {
        iconLayout: 'default#image',
        iconImageHref: markerIcon,
        iconImageSize: [48, 48],
        iconImageOffset: Site.isMobile ? [-48, -35] : [-14, -14],
      });
      map.geoObjects.add(marker);

      function buildRoutes() {
        const address = inputField.value.trim();
        if (!address) return;

        ymaps.geocode(address, { results: 1 }).then(result => {
          const firstGeoObject = result.geoObjects.get(0);
          if (firstGeoObject) {
            const startCoords = firstGeoObject.geometry.getCoordinates();
            Object.values(currentRoutes).forEach(route => map.geoObjects.remove(route));
            currentRoutes = {};

            ["driving", "masstransit", "pedestrian"].forEach(mode => {
              const route = new ymaps.multiRouter.MultiRoute({
                referencePoints: [startCoords, latlng],
                params: { routingMode: mode, results: 1 },
              }, {});
              currentRoutes[mode] = route;
              route.model.events.add("requestsuccess", () => {
                map.setBounds(map.geoObjects.getBounds(), {
                  zoomMargin: Site.isMobile ? [10, 10, 320, 10] : [350, 20, 20, 400],
                  checkZoomRange: true,
                  preciseZoom: true,
                  duration: 300,
                });
                updateRouteTimes();
              });
            });
            updateDisplayedRoute();
            $routeTabsContainer.css('display', 'block');
            $actionRoutesButton.css('display', 'block');
            $actionRoutesButton.removeClass('_active');
          }
        });
      }

      function updateRouteTimes() {
        Object.keys(currentRoutes).forEach(mode => {
          const route = currentRoutes[mode];
          const $routeTab = $(`.route__tab[data-tab="${mode}"]`);
          if (!$routeTab) return;
          const duration = route.getRoutes().get(0)?.properties.get("duration")?.text || "";
          $routeTab.find(".route__time").text(duration);
          $routeTab.css("display", duration ? "flex" : "none");
        });
      }

      function updateDisplayedRoute() {
        Object.values(currentRoutes).forEach(route => map.geoObjects.remove(route));
        const newRoute = new ymaps.multiRouter.MultiRoute({
          referencePoints: currentRoutes[selectedMode].model.getReferencePoints(),
          params: { routingMode: selectedMode, results: 1 },
        }, {
          wayPointVisible: false,
          routeActiveStrokeColor: "#062E1D99",
          routeActiveStrokeStyle: "2 2",
          routeActiveStrokeWidth: 4,
          routeActiveStrokeOpacity: 1,
        });
        map.geoObjects.add(newRoute);
        currentRoutes[selectedMode] = newRoute;
        updateActiveTabText();
      }

      function updateActiveTabText() {
        const $activeTab = $(`.route__tabs .route__mod`);
        if ($activeTab) {
          $activeTab.text({ driving: "На автомобиле", masstransit: "На автобусе", pedestrian: "Пешком" }[selectedMode] || "Неизвестный маршрут");
        }
      }

      $buildRouteButton.click(function () {
        if (!inputField.offsetWidth) {
          inputField.style.display = "block";
          inputField.focus();
          return;
        }
        buildRoutes();
      })

      $actionRoutesButton.click(function () {
        if ($(this).hasClass('_active')) {
          buildRoutes();

          return;
        }

        Object.values(currentRoutes).forEach(route => map.geoObjects.remove(route));
        currentRoutes = {};
        $routeTabsContainer.css("display", "none");
        $actionRoutesButton.addClass("_active");
        inputField.value = "";
      })

      $routeTabs.click(function () {
        $routeTabs.removeClass("_active");
        $(this).addClass("_active");
        selectedMode = $(this).attr("data-tab");
        updateDisplayedRoute();
      });

      if (!Site.isMobile && $zoomPlus && $zoomMinus) {
        $zoomPlus.click(function () {
          map.setZoom(map.getZoom() + 1, { duration: 300 });
        })

        $zoomMinus.click(function () {
          map.setZoom(map.getZoom() - 1, { duration: 300 });
        })
      }
    });
  }
}

const Site = {
  isMobile: window.innerWidth <= 1000,
  prevScroll: 0,
  init: function () {
    $('.menu__close').on('click', function () {
      $('.menu').removeClass('active');
      popupStack.pop();
    });

    $('.m_burger').on('click', function () {
      $('.menu').addClass('active');
      popupStack.push('menu');
    });

    gsap.registerPlugin(window.ScrollTrigger, window.ScrollSmoother);

    if (Site.isMobile) {
      Site.initMobile();
    } else {
      Site.initDesctope();
    }

    var st;
    window.onresize = function () {
      clearTimeout(st);
      st = setTimeout(Site.resize, 100);
    };

    const tolerance = 5;
    $(window).scroll(function () {
      const scr = parseInt(window.scrollY);

      if (Math.abs(scr - Site.prevScroll) > tolerance) { // Игнорируем мелкие изменения
        if (scr > Site.prevScroll && scr >= 50) {
          $('header').addClass('hide');
        } else if (scr < Site.prevScroll) {
          $('header').removeClass('hide');
        }

        if (scr > window.innerHeight) {
          $('header').addClass('diff');
        } else {
          $('header').removeClass('diff');
        }

        Site.prevScroll = scr; // Обновляем значение только при значимых изменениях
      }
    });

    $('footer .logo').click(function () {
      if (Site.smoother) {
        Site.smoother.scrollTo(0, false);
      }
    });
  },
  resize: function () {
    var m = window.innerWidth <= 1000;

    if (Site.isMobile != m) {
      Site.isMobile = m;

      if (Site.isMobile) {
        Site.initMobile();
      } else {
        Site.initDesctope();
      }

      location.reload();
    }
  },
  initMobile: function () {
    LazyLoad.init();

    $(window).scroll(function () {
      LazyLoad.init();
    });

    const animTitle = document.querySelectorAll('.anim-title');
    if ($('#sec-8-cont').length) {
      if (window.slider_sec8) {
        window.slider_sec8.destroy();
      }
      Site.Sec8Slider();
    }
    if ($('#sec-8-cont-2').length) {
      if (window.slider_secTeam) {
        window.slider_secTeam.destroy();
      }
      Site.SecTeamSlider();
    }
    animTitle.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.section2', {
      scrollTrigger: {
        trigger: '.sec-10',
        start: 'top +=10%',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function (s) {
          if (Site.galleryslider) {
            Site.galleryslider.autoplay.start();
          }
        },
        onLeave: function () {
          if (Site.galleryslider) {
            Site.galleryslider.slideTo(0)
            Site.galleryslider.autoplay.stop();
          }
        },
      },
    });

    $('.menu__list div').on('click', function () {
      const index = $(this).index();
      popupStack.pop();
      $('.menu').removeClass('active');
      if (index == 0) {
        $('.section2')[0].scrollIntoView();
      }
      if (index == 1) {
        $('.sec-10')[0].scrollIntoView();
      }
      if (index == 2) {
        $('.section7')[0].scrollIntoView();
      }
      if (index == 3) {
        $('.pano')[0].scrollIntoView();
      }
      if (index == 4) {
        $('.section4-title')[0].scrollIntoView();
      }
      if (index == 5) {
        $('.sec7')[0].scrollIntoView();
      }
      if (index == 6) {
        $('.pin-wrapper-team')[0].scrollIntoView();
      }
      if (index == 7) {
        $('.s_din')[0].scrollIntoView();
      }
      if (index == 8) {
        $('.s_about')[0].scrollIntoView();
      }
      if (index == 9) {
        $('.s_contacts')[0].scrollIntoView();
      }
      setTimeout(function () {
        $('header').addClass('hide');
      }, 100);
    });
    setTimeout(() => {
      this.mobileAnimation();
    }, 50);
  },
  mobileAnimation: function () {
    window.gsap.to('.sec3__img', {
      scrollTrigger: {
        trigger: '.sec3__img',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sec__4-img div', {
      scrollTrigger: {
        trigger: '.sec__4-img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '35%',
    });

    window.gsap.to('.se4__img3 div', {
      scrollTrigger: {
        trigger: '.se4__img3',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
      width: '100%',
    });
    window.gsap.to('.se4__img2 img:first-child, .se4__img2 img:last-child', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });
    window.gsap.to('.se4__img2 img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    const sec6Text = document.querySelectorAll('.sec6-text-flex-wrap');
    sec6Text.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.pin-wrapper .section4-title', {
      scrollTrigger: {
        trigger: '.pin-wrapper .section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.pin-wrapper > .section4').classList.add('active');
        },
      },
    });

    window.gsap.to('.pin-wrapper-team .section4-title', {
      scrollTrigger: {
        trigger: '.pin-wrapper-team .section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.pin-wrapper-team > .section4').classList.add('active');
        },
      },
    });

    window.gsap.to('.section4 .sec_lines img:first-child, .section4 .sec_lines img:last-child', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.section4 .sec_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec11-img-1 div', {
      scrollTrigger: {
        trigger: '.sec11-img-1',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
    });

    window.gsap.to('.sec11-img-2 div', {
      scrollTrigger: {
        trigger: '.sec11-img-2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines img:first-child, .din_lines img:last-child', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    $('#go-to-flats').on('click', (e) => {
      e.preventDefault()
      $('#flats')[0].scrollIntoView();
    })
  },
  Sec8Slider: function () {
    window.slider_sec8 = new Swiper('#sec-8-cont .swiper', {
      slidesPerView: 1,
      //speed: 1000,
      spaceBetween: 0,
      allowTouchMove: true,
      breakpoints: {
        1001: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {},
        slideChange: function (swiper) {
          window.gsap.killTweensOf(document.querySelector('#sec-8-cont .swiper-wrapper'));
        },
      },
    });
  },
  SecTeamSlider: function () {
    window.slider_secTeam = new Swiper('#sec-8-cont-2 .swiper', {
      slidesPerView: 1,
      //speed: 1000,
      spaceBetween: 0,
      allowTouchMove: true,
      breakpoints: {
        1001: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {},
        slideChange: function (swiper) {
          window.gsap.killTweensOf(document.querySelector('#sec-8-cont-2 .swiper-wrapper'));
        },
      },
    });
  },
  initDesctope: function () {
    const self = this;
    if ($('#sec-8-cont').length) {
      if (window.slider_sec8) {
        window.slider_sec8.destroy();
      }
      Site.Sec8Slider();
    }
    if ($('#sec-8-cont-2').length) {
      if (window.slider_secTeam) {
        window.slider_secTeam.destroy();
      }
      Site.SecTeamSlider();
    }
    Site.smoother = ScrollSmoother.create({
      smooth: 2,
      smoothTouch: 2,
      normalizeScroll: true,
      onUpdate: function (s) {
        LazyLoad.init();
      },
    });

    $('.menu__list div').on('click', function () {
      const index = $(this).index();
      $('.menu').removeClass('active');
      popupStack.pop();
      if (index == 0) {
        Site.smoother.scrollTo('.section2');
      }
      if (index == 1) {
        Site.smoother.scrollTo('.sec-10');
      }
      if (index == 2) {
        Site.smoother.scrollTo('.section7');
      }
      if (index == 3) {
        Site.smoother.scrollTo('.pano');
      }
      if (index == 4) {
        Site.smoother.scrollTo('.section4-title');
      }
      if (index == 5) {
        Site.smoother.scrollTo('.sec7');
      }
      if (index == 6) {
        Site.smoother.scrollTo('.pin-wrapper-team');
      }
      if (index == 7) {
        Site.smoother.scrollTo('.s_din');
      }
      if (index == 8) {
        Site.smoother.scrollTo('.s_about');
      }
      if (index == 9) {
        Site.smoother.scrollTo('.s_contacts');
      }
      setTimeout(function () {
        $('header').addClass('hide');
      }, 100);
    });
    setTimeout(() => {
      this.desktopAnimation();
    }, 50);
  },
  desktopAnimation: function () {
    window.gsap.to('.sec3__img div', {
      scrollTrigger: {
        trigger: '.sec3__img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    });

    const animTitle = document.querySelectorAll('.anim-title');
    animTitle.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    try {
      window.gsap.to('.sec2__subTitle div:last-child', {
        scrollTrigger: {
          trigger: '.sec2__subTitle',
          start: 'top bottom',
          end: '+=' + window.innerHeight,
          scrub: true,
        },
        duration: 0.6,
        x: '115%',
      });
    } catch (e) {
      console.error('Error .sec2__subtitle: ', e);
    }

    window.gsap.to('.sec__4-img div', {
      scrollTrigger: {
        trigger: '.sec__4-img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '15%',
    });

    window.gsap.to('.sec4__text', {
      scrollTrigger: {
        trigger: '.sec4__text',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.se4__img3 div', {
      scrollTrigger: {
        trigger: '.se4__img3',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
      width: '100%',
    });

    window.gsap.to('.se4__img2 img:first-child, .se4__img2 img:last-child', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.se4__img2 img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec4-wrap-center > div:nth-child(2n)', {
      scrollTrigger: {
        trigger: '.sec4-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '50%',
    });

    window.gsap.to('.sec4-wrap-center > div:nth-child(2n+1)', {
      scrollTrigger: {
        trigger: '.sec4-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '-50%',
    });

    window.gsap.to('.sec5-img > span', {
      scrollTrigger: {
        trigger: '.sec5-img',
        start: 'top center-=' + window.innerHeight / 6,
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '-100%',
      x: '-100%',
    });

    const sec6Text = document.querySelectorAll('.sec6-text-flex-wrap');
    sec6Text.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.sec7 .slider-loc2', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top bottom-=' + window.innerHeight / 5,
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sec7', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function (s) {
          Main.swiper3.params.autoplay = {
            delay: 6000,
            disableOnInteraction: true,
          };

          Main.swiper3.autoplay.start();
        },
      },
    });

    window.gsap.to('.slider-loc__bg', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top bottom-=' + window.innerHeight / 4,
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      scaleX: 0,
    });

    window.advSectionTl1 = window.gsap.to('.pin-wrapper .section4-title', {
      scrollTrigger: {
        trigger: '.pin-wrapper .section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.pin-wrapper > .section4').classList.add('active');
        },
      },
    });

    if (!matchMedia('(pointer:coarse)').matches) {
      window.advSectionTl2 = window.gsap.to('.pin-wrapper', {
        scrollTrigger: {
          trigger: '.pin-wrapper',
          start: () => {
            const el = document.querySelector('.pin-wrapper .section4-title');
            const sliderHeight = document.querySelector('#sec-8-cont')?.clientHeight * 0.5;
            const top = el?.offsetTop + el.clientHeight + sliderHeight;
            return `top+=${top} center`;
          },
          end: '+=' + window.innerHeight,
          scrub: true,
          pin: true,
        },
      });
      window.teamSectionTl2 = window.gsap.to('.pin-wrapper-team', {
        scrollTrigger: {
          trigger: '.pin-wrapper-team',
          start: () => {
            const el = document.querySelector('.pin-wrapper-team .section4-title');
            const sliderHeight = document.querySelector('#sec-8-cont-2')?.clientHeight * 0.5;
            const top = el?.offsetTop + el.clientHeight + sliderHeight;
            return `top+=${top} center`;
          },
          end: '+=' + window.innerHeight,
          scrub: true,
          pin: true,
        },
      });

      window.advSectionTl3 = window.gsap.to('#sec-8-cont .swiper-wrapper', {
        scrollTrigger: {
          trigger: '.pin-wrapper',
          start: () => {
            const el = document.querySelector('.pin-wrapper .section4-title');
            const sliderHeight = document.querySelector('#sec-8-cont')?.clientHeight * 0.5;
            const top = el?.offsetTop + el.clientHeight + sliderHeight;
            return `top+=${top} center`;
          },
          end: '+=' + window.innerHeight,
          scrub: true,
        },
        duration: 0.6,
        x: () => {
          const el = $('#sec-8-cont .swiper-wrapper');
          const slides = el.children();
          const count = slides.length;
          return -(slides.eq(0).width() * count - window.innerWidth);
        },
      });

      window.teamSectionTl3 = window.gsap.to('#sec-8-cont-2 .swiper-wrapper', {
        scrollTrigger: {
          trigger: '.pin-wrapper-team',
          start: () => {
            const el = document.querySelector('.pin-wrapper-team .section4-title');
            const sliderHeight = document.querySelector('#sec-8-cont-2')?.clientHeight * 0.5;
            const top = el?.offsetTop + el.clientHeight + sliderHeight;
            return `top+=${top} center`;
          },
          end: '+=' + window.innerHeight,
          scrub: true,
        },
        duration: 0.6,
        x: () => {
          const el = $('#sec-8-cont-2 .swiper-wrapper');
          const slides = el.children();
          const count = slides.length;
          return -(slides.eq(0).width() * count - window.innerWidth);
        },
      });
    }



    window.teamSectionTl1 = window.gsap.to('.pin-wrapper-team .section4-title', {
      scrollTrigger: {
        trigger: '.pin-wrapper-team .section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.pin-wrapper-team > .section4').classList.add('active');
        },
      },
    });


    window.gsap.to('.section4 .sec_lines img:first-child, .section4 .sec_lines img:last-child', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.section4 .sec_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec-9 div', {
      scrollTrigger: {
        trigger: '.section5',
        start: 'top top+=' + window.innerHeight,
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
    });

    const sec10elements = document.querySelectorAll('.sec-10-left-item');
    sec10elements.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.sec11-img-1 div', {
      scrollTrigger: {
        trigger: '.sec11-img-1',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
    });

    window.gsap.to('.sec11-img-2 div', {
      scrollTrigger: {
        trigger: '.sec11-img-2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines img:first-child, .din_lines img:last-child', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.s_about_slogon', {
      scrollTrigger: {
        trigger: '.s_about_slogon',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.s_about_info', {
      scrollTrigger: {
        trigger: '.s_about_info',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      y: 0,
    });

    // window.gsap.to('.s_contacts__info', {
    //   scrollTrigger: {
    //     trigger: '.s_contacts__info',
    //     start: 'top bottom',
    //     end: '+=' + window.innerHeight,
    //     scrub: true,
    //   },
    //   duration: 0.6,
    //   x: 0,
    // });

    window.gsap.to('.sec7-wrap-center .sec4-wrap-item', {
      scrollTrigger: {
        trigger: '.sec7-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight / 2,
        scrub: true,
      },
      duration: 0.6,
      y: 0,
    });

    window.gsap.to('.sec12-flat-wrap .slider-flat1', {
      scrollTrigger: {
        trigger: '.sec12-flat-wrap .slider-flat1',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    $('#go-to-flats').on('click', () => {
      Site.smoother.scrollTo('#flats');
    })
  },
};

const Calc = {
  shortval: (v) => v && String(v / 1000000).match(/\d+(?:\.\d)?/)[0],
  updateHandleValue: (el, value, base, min, max) => {
    const floatingValue = $(el).closest('.calc__slider-value');
    const norm = (base - min) / (max - min);
    floatingValue.attr('data-v', value);
    floatingValue.css('--slider-p', (isNaN(norm) ? 0 : norm) * 100 + '%');
  },
  init: function () {
    Calc.frmt = new Intl.NumberFormat();

    $.ajax({
      url: isDev ? 'src/ajax/credit_info.json' : '/api/?w=credit_info',
      method: 'get',
      contentType: 'application/json',
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          Calc.bank = 0;
          Calc.type = 0;

          $('.calc__slider[data-name="price"]').attr('data-min', response.data.price[0]);
          $('.calc__slider[data-name="price"]').attr('data-max', response.data.price[1]);

          Calc.price = response.data.price_default;

          $('.calc__slider[data-name="first"]').attr('data-min', Math.ceil(response.data.price[0] / 10));
          $('.calc__slider[data-name="first"]').attr('data-max', response.data.first[1]);

          Calc.first = response.data.first_default;

          $('.calc__slider[data-name="period"]').attr('data-min', response.data.period[0]);
          $('.calc__slider[data-name="period"]').attr('data-max', response.data.period[1]);

          Calc.period = response.data.period_default;

          $('.calc__slider').each(function () {
            const name = $(this).attr('data-name');
            // const value = $(this).parent().prev('.calc__value');
            const min = parseInt($(this).data('min'));
            const max = parseInt($(this).data('max'));
            $(this).slider({
              min,
              max,
              value: Calc[name],
              create: function (event, ui) {
                let v;
                switch (name) {
                  case 'period':
                    v = Calc.frmt.format(Calc[name]);
                    break;
                  case 'first':
                    Calc.balanceValues(Calc.price);
                    return;
                  default:
                    v = Calc.shortval(Calc[name]);
                    break;
                }
                Calc.updateHandleValue(event.target, v, Calc[name], min, max);
              },
              change: function (event, ui) {
                Calc.getPrograms();
              },
              slide: function (event, ui) {
                Calc[name] = ui.value;
                let v;
                switch (name) {
                  case 'period':
                    v = Calc.frmt.format(ui.value);
                    break;
                  case 'price':
                    Calc.balanceValues(ui.value);
                  default:
                    v = Calc.shortval(ui.value);
                    break;
                }
                let newMax = max;
                if (name === 'first') {
                  newMax = $('.calc__slider[data-name="first"]').slider('option', 'max');
                  const r = (($('.calc__slider[data-name="first"]').slider('value') / $('.calc__slider[data-name="price"]').slider('value')) * 100).toFixed(0);
                  v = v + '—' + r + '%';
                }
                Calc.updateHandleValue(event.target, v, ui.value, min, newMax);
              },
            });
          });

          for (let key in response.data.banks) {
            $('.calc__select select[name="banks"]').append('<option value="' + key + '">' + response.data.banks[key] + '</option>');
          }

          for (let key in response.data.types) {
            $('.calc__select select[name="types"]').append('<option value="' + key + '">' + response.data.types[key] + '</option>');
          }

          $('.calc__select select').each(function () {
            const name = $(this).attr('name');
            $(this).selectmenu({
              change: function (event, ui) {
                if (name == 'banks') {
                  Calc.bank = ui.item.value;
                }
                if (name == 'types') {
                  Calc.type = ui.item.value;
                }

                Calc.getPrograms();
              },
              open: function () {
                popupStack.push('select');
              },
              close: function () {
                popupStack.pop();
              },
            });
          });

          $('.calc__table td[data-type]').on('click', function () {
            const asc = $(this).hasClass('active');
            $(this).toggleClass('active', !asc).siblings().removeClass('active');
            Calc.sort = { asc, type: $(this).data('type') };
            Calc.renderPrograms();
          });

          Calc.getPrograms();

          $('.calc__btn .btn').click(function () {
            Calc.max = Calc.max + 5;
            Calc.renderPrograms();
          });
        }
      },
    });
  },
  balanceValues: function (price) {
    const firstEl = $('.calc__slider[data-name="first"]');
    const min = +firstEl.slider('option', 'min');
    const max = price * 0.9;
    const base = +firstEl.slider('value');

    firstEl.slider('option', 'max', max);
    const r = ((base / price) * 100).toFixed(0);
    const value = Calc.shortval(base) + '—' + r + '%';

    Calc.updateHandleValue(firstEl, value, base, min, max);
  },
  declOfNum: function (number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  },
  max: 5,
  data: null,
  getPrograms: function () {
    const data = {
      period: Calc.period,
      price: Calc.price,
      first: Calc.first,
    };

    if (Calc.type && Calc.type != 0) {
      data.type = Calc.type;
    }

    if (Calc.bank && Calc.bank != 0) {
      data.bank = Calc.bank;
    }

    $.ajax({
      url: isDev ? 'src/ajax/credit.json' : '/api/?w=credit',
      method: 'get',
      contentType: 'application/json',
      dataType: 'json',
      data,
      success: function (response) {
        if (response.success) {
          Calc.max = 5;
          Calc.data = response.data;
          Calc.renderPrograms();
        }
      },
    });
  },
  renderPrograms: function () {
    // if (Calc.data.length <= Calc.max) {
    //   $('.calc__btn').addClass('hide');
    // } else {
    //   $('.calc__btn').removeClass('hide');
    // }

    if (Calc.sort?.type) {
      const f = Calc.sort.type;
      Calc.data?.sort((a, b) => {
        if (a[f] < b[f]) return -1;
        return a[f] > b[f] ? 1 : 0;
      });
      Calc.sort.asc && Calc.data.reverse();
    }

    if (Site.isMobile) {
      $('.calc td[data-remove-on-xs]')?.remove();
    }

    $('.calc table tbody').children().remove();
    Calc.data.forEach((item, index) => {
      const specialRate = item.special_rate ? ` <span>на ${item.special_rate_period}</span>` : '';
      if (index <= Calc.max) {
        $('.calc table tbody').append(
          `<tr>
            <td>
            <div><img src="${item.bankLogo}"> ${item.bankName}</div>
            </td>
            <td>${item.rate}${specialRate}</td>
            <td>${item.period}</td>
            <td>${Calc.frmt.format(item.amount)} ₽</td>
            ${Site.isMobile ? '' : '<td><div class="btn -fill -brd"><span>оставить заявку</span></div></td>'}
          </tr>`,
        );
      }
    });

    $('.calc table .btn').on('click', function () {
      showCallMePoup();
    });
  },
};

const Gallery = {
  imgs: [],
  titles: null,
  swiper: null,
  init: function () {
    $('.sec-10 .sec-10-left-item,.sec-10-mobslider__images .sec-10-left-item-bg').click(function () {
      const imgs = $(this).attr('data-src').split('|');
      const title = $(this).find('.sec10-item-title-hidden').text();
      $('.popup-images[data-type="gallery"] .popup-images__title').text(title);
      popupStack.push('gallery');
      Gallery.imgs = [];
      Gallery.imgs = imgs;
      Gallery.titles = null;
      Gallery.show();
    });

    $('.popup-images[data-type="gallery"] .popup-images__close').click(function () {
      popupStack.pop();
      Gallery.hide();
    });

    $('.sec-10-mobslider__title').click(function () {
      $('.sec-10-mobslider__images .swiper-slide:eq(' + $(this).index() + ') .sec-10-left-item-bg').click();
    });
  },
  setIndex: function (index) {
    $('.popup-images[data-type="gallery"] .popup-images__arrows span').text(index + 1 + '/' + Gallery.imgs.length);

    if (Array.isArray(Gallery.titles)) {
      $('.popup-images[data-type="gallery"] .popup-images__title').text(Gallery.titles[index]);
    }
  },
  show: function () {
    $('.popup-images[data-type="gallery"] .swiper-wrapper').children().remove();

    Gallery.imgs.forEach((item) => {
      $('.popup-images[data-type="gallery"] .swiper-wrapper').append(
        `
        <div class="swiper-slide">
          <div class="popup-images__slide">
            <div style="background-image: url('${item}')"></div>
          </div>
        </div>
        `,
      );
    });

    Gallery.swiper = new Swiper('.popup-images[data-type="gallery"] .swiper', {
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      /*pagination: {
        el: '.popup-images[data-type="gallery"] .popup-images__pagination',
        clickable: true,
      },*/
      navigation: {
        nextEl: '.popup-images[data-type="gallery"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="gallery"] .popup-images__arrows div:first-child',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange: function (e) {
          Gallery.setIndex(e.activeIndex);
        },
        afterInit: function () {
          $('.popup-images[data-type="gallery"]').addClass('active');
        },
      },
    });

    Gallery.setIndex(0);
  },
  hide: function () {
    Gallery.swiper.destroy();
    Gallery.swiper = null;
    Gallery.titles = null;
    Gallery.imgs = [];
    $('.popup-images[data-type="gallery"]').removeClass('active');
  },
};

const Adv = {
  swiper: null,
  isInit: false,
  start: function () {
    $('.popup-images[data-type="adv"] .popup-images__close').on('click', function () {
      popupStack.pop();
      $('.popup-images[data-type="adv"]').removeClass('active');
    });

    $('.pin-wrapper .section4 .swiper-slide').on('click', function () {
      popupStack.push('adv');
      if (!Adv.isInit) {
        Adv.init();
      }

      $('.popup-images[data-type="adv"]').addClass('active');
      const index = $(this).index();
      Adv.setIndex(index);
    });
  },
  init: function () {
    Adv.isInit = true;

    $('.pin-wrapper .section4 .swiper-slide').each(function (index) {
      const imgs = $(this).attr('data-src').split('|');
      const title = $(this).find('.sec-8-cont-item-text').text();
      const dsc = $(this).attr('data-dsc');

      let sIn = '';
      imgs.forEach((item) => {
        sIn += `
          <div>
            <div class="popup-images__adv-inner-slide" style="background-image: url('${item}')"></div>
          </div>
        `;
      });

      $('.popup-images[data-type="adv"] .swiper-outer .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-images__adv-outer-slide">
            <div class="popup-images__adv-block">
              <div class="popup-images__title">${title}</div>
              <div class="popup-images__dsc">${dsc}</div>
            </div>

            <div class="slick-inner" data-id="${index}">
              ${sIn}
            </div>
          </div>
        </div>`);
    });

    Adv.swiper = new Swiper('.popup-images[data-type="adv"] .swiper-outer', {
      loop: false,
      speed: 900,
      autoHeight: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '.popup-images[data-type="adv"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="adv"] .popup-images__arrows div:first-child',
      },
      on: {
        slideChange: function (e) {
          Adv.setIndex(e.activeIndex);
        },
        afterInit: function () {
          $('.popup-images[data-type="adv"] .slick-inner').each(function () {
            $(this).slick({
              dots: true,
              infinite: false,
              variableWidth: true,
              slidesToShow: 1,
              arrows: false,
            });
          });
        },
      },
      breakpoints: {
        1000: {
          autoHeight: false,
        },
      },
    });
  },
  setIndex: function (index) {
    Adv.swiper.slideTo(index, 0);
    $('.popup-images[data-type="adv"] .popup-images__arrows span').text(index + 1 + '/' + $('.pin-wrapper .section4 .swiper-slide').length);
  },
};

const Team = {
  swiper: null,
  isInit: false,
  start: function () {
    $('.popup-images[data-type="team"] .popup-images__close').on('click', function () {
      popupStack.pop();
      $('.popup-images[data-type="team"]').removeClass('active');
    });

    $('.pin-wrapper-team .section4 .swiper-slide').on('click', function () {
      popupStack.push('team');
      if (!Team.isInit) {
        Team.init();
      }

      $('.popup-images[data-type="team"]').addClass('active');
      const index = $(this).index();
      Team.setIndex(index);
    });
  },
  init: function () {
    Team.isInit = true;

    $('.pin-wrapper-team .section4 .swiper-slide').each(function (index) {
      const imgs = $(this).attr('data-src').split('|');
      const title = $(this).find('.sec-8-cont-item-text').text();
      const dsc = $(this).attr('data-dsc');

      let sIn = '';
      imgs.forEach((item) => {
        sIn += `
          <div>
            <div class="popup-images__adv-inner-slide" style="background-image: url('${item}')"></div>
          </div>
        `;
      });

      $('.popup-images[data-type="team"] .swiper-outer .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-images__adv-outer-slide">
            <div class="popup-images__adv-block">
              <div class="popup-images__title">${title}</div>
              <div class="popup-images__dsc">${dsc}</div>
            </div>

            <div class="slick-inner" data-id="${index}">
              ${sIn}
            </div>
          </div>
        </div>`);
    });

    Team.swiper = new Swiper('.popup-images[data-type="team"] .swiper-outer', {
      loop: false,
      speed: 900,
      autoHeight: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '.popup-images[data-type="team"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="team"] .popup-images__arrows div:first-child',
      },
      on: {
        slideChange: function (e) {
          Team.setIndex(e.activeIndex);
        },
        afterInit: function () {
          $('.popup-images[data-type="team"] .slick-inner').each(function () {
            $(this).slick({
              dots: true,
              infinite: false,
              variableWidth: true,
              slidesToShow: 1,
              arrows: false,
            });
          });
        },
      },
      breakpoints: {
        1000: {
          autoHeight: false,
        },
      },
    });
  },
  setIndex: function (index) {
    Team.swiper.slideTo(index, 0);
    $('.popup-images[data-type="team"] .popup-images__arrows span').text(index + 1 + '/' + $('.pin-wrapper-team .section4 .swiper-slide').length);
  },
};

const PopupMedia = {
  swiper: null,
  init() {
    $('[media-popup-src]').off('click').on('click', function () {
      popupStack.push('popupmedia');
      const type = $(this).attr('data-type');
      const src = $(this).attr('media-popup-src');

      if (type === 'photo') {
        PopupMedia.showGallery($(this));
      } else {
        PopupMedia.showMedia(src, $(this));
      }
    });

    $('.popup-images[data-type="media"] .popup-images__close').on('click', function () {
      popupStack.pop();
      PopupMedia.destroyPlayers();
      PopupMedia.destroySlider();
      $('.popup-images[data-type="media"]').removeClass('active');
    });
  },

  showGallery(element) {
    const imgs = element.attr('media-popup-src').split('|');
    const title = element.find('.s_din__item__title').text();
    $('.popup-images[data-type="gallery"] .popup-images__title').text(title);
    Gallery.imgs = imgs;
    Gallery.show();
  },

  showMedia(src, element) {
    $('.popup-image__media').removeAttr('style');
    $('.popup-image__content .swiper-wrapper').empty();

    if (src.includes('.m3u8')) {
      PopupMedia.createHLSPlayer(src);
    } else if (src.includes('.mp4')) {
      PopupMedia.createMP4Player(src);
    } else if (src.includes('www.youtube.com')) {
      PopupMedia.createYouTubeEmbed(src);
    } else {
      PopupMedia.createImageSlides(src);
    }

    $('.popup-images[data-type="media"]').addClass('active');
  },

  createHLSPlayer(src) {
    $('.popup-image__media-title').text('Трансляции');
    const sources = src.split('|');
    sources.forEach((item, index) => {
      $('.popup-image__content .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-image__media -broadcast">
            <video id="my-video-${index}" class="video-js vjs-default-skin" controls preload="auto" data-setup='{"fluid": true}'>
              <source src="${item}" type="application/x-mpegURL" />
            </video>
          </div>
        </div>
      `);
    });

    const initPlayer = () => {
      $('.swiper-slide video').each((_, video) => video.pause());
      setTimeout(() => {
        const activeSlide = $('.swiper-slide-active video');
        if (activeSlide.length) {
          const activeVideoId = activeSlide.attr('id');
          let player = videojs.getPlayer(activeVideoId) || videojs(activeVideoId);
          player.play();
        }
      }, 200);
    };

    if (sources.length > 1) PopupMedia.initSlider(initPlayer);
  },

  pauseInactiveVideo (){
    const video = $('.popup-image__content .swiper-slide-active video').get(0);
    if (video) {
      video.pause();
      $(video).siblings('.popup-image__media-btn').show();
    }
  },

  createMP4Player(src) {
    $('.popup-image__media-title').text('Видео');

    const sources = src.split('|');
    sources.forEach(item => {
      $('.popup-image__content .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-image__media -broadcast">
            <video loop>
              <source src="${item}" type="video/mp4">
            </video>
            <div class="popup-image__media-btn">
              <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38 31C38 42.598 50.9838 52 67 52C50.9838 52 38 61.402 38 73" stroke="#CFC7BF" stroke-width="2"/>
                <rect x="1" y="1" width="102" height="102" stroke="#CFC7BF" stroke-width="2"/>
              </svg>
            </div>
          </div>
        </div>
      `);
    });

    $('.popup-image__media-btn').on('click', function () {
      $(this).hide();
      $(this).siblings('video')[0].play();
    });



    if (sources.length > 1) PopupMedia.initSlider(PopupMedia.pauseInactiveVideo);
  },

  resetIframeSrc (){
    const iframe = $('.popup-image__content .swiper-slide-active iframe');
    if (iframe.length) {
      const src = iframe.attr('src');
      iframe.attr('src', ''); // Сбрасываем src (останавливаем видео)
      iframe.attr('src', src);
    }
  },

  createYouTubeEmbed(src) {
    $('.popup-image__media-title').text('Видео');

    const sources = src.split('|');
    sources.forEach(item => {
      $('.popup-image__content .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-image__media">
            <iframe width="560" height="315" src="${item}" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>
      `);
    });

    if (sources.length > 1) PopupMedia.initSlider(PopupMedia.resetIframeSrc);
  },

  createImageSlides(src) {
    $('.popup-image__media-title').text('��от����');

    const sources = src.split('|');
    sources.forEach(item => {
      $('.popup-image__content .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-image__media" style="background-image: url('${item}')"></div>
        </div>
      `);
    });

    if (sources.length > 1) PopupMedia.initSlider();
  },

  setIndex(index, count) {
    $('.popup-images[data-type="media"] .popup-images__arrows span').text(`${index + 1}/${count}`);
  },

  initSlider(onSlideChange) {
    PopupMedia.swiper = new Swiper('.popup-images[data-type="media"] .swiper', {
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: '.popup-images[data-type="media"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="media"] .popup-images__arrows div:first-child',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange(e) {
          PopupMedia.setIndex(e.activeIndex, e.slides.length);
          if (onSlideChange) onSlideChange();
        },
        afterInit(e) {
          $('.popup-images[data-type="media"]').addClass('active');
          if (e.slides.length > 1) {
            $('.popup-images[data-type="media"] .popup-images__arrows').css('display', 'flex');
          }
          PopupMedia.setIndex(0, e.slides.length);
          if (onSlideChange) onSlideChange();
        },
      },
    });
  },

  destroySlider() {
    if (PopupMedia.swiper) {
      PopupMedia.swiper.destroy();
      PopupMedia.swiper = null;
    }
    $('.popup-images[data-type="media"] .popup-images__arrows').hide();
    $('.popup-image__content .swiper-wrapper').empty();
  },
  destroyPlayers() {
    // Уничтожение всех video.js плееров перед очисткой контента
    $('.popup-image__content video').each((_, video) => {
      if (!video.id) return;

      const player = videojs.getPlayer(video.id);
      if (player) {
        player.dispose(); // Уничтожаем инстанс плеера
      }
    });
  },
};

const Cookie = {
  init: function () {
    if (!localStorage.getItem('scookie')) {
      $('.cookie').addClass('active');
    }

    $('.cookie').click(function () {
      $('.cookie').removeClass('active');
      localStorage.setItem('scookie', 'true');
    });
  },
};

const Payment = {
  state: {
    data: undefined,
    swiper: undefined,
    activeTab: undefined,
  },
  block: $('.payment-options'),
  init: function () {
    if (!this.block.length) {
      console.log('There is no payemnt block...');
      return;
    }
    const payment = this;
    this.state = new Proxy(this.state, {
      set(target, key, value) {
        target[key] = value;
        switch (key) {
          case 'data':
            payment.initTabs();
          case 'activeTab':
            if (value !== undefined) {
              payment.renderSlides();
              payment.initSwiper();
            }
            break;
          default:
            break;
        }
        return Reflect.set(...arguments);
      },
    });
    this.getData();
  },
  async getData() {
    const response = await fetch(isDev ? 'src/ajax/payment_types.json' : '/api/?w=payment_types');
    const { data } = await response.json();
    if (!(data.paymentOptions && data.paymentOptions.length)) {
      this.hideBlock();
      return;
    }
    this.state.data = data.paymentOptions;
  },
  hideBlock() {
    $('.menu__list > div:contains("способы оплаты")')?.remove();
    this.block?.closest('.payment-wrap')?.hide();
  },
  initSwiper() {
    const swiperBlock = this.block.find('.swiper');

    this.state.swiper?.destroy(true, true);

    this.state.swiper = new Swiper(swiperBlock.get(0), {
      slidesPerView: '4',
      spaceBetween: 16,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: this.block.find('.slider-nav .next').get(0),
        prevEl: this.block.find('.slider-nav .prev').get(0),
      },
      on: {
        click(swiper, { target }) {
          const el = $(target).closest('.btn');
          if (!el.length) return;
          const type = el.data('type');
          type === 'mortgage' ? showMortgagePopup() : showCallMePoup();
        },
      },
    });
  },
  initTabs() {
    try {
      const tabsBlock = this.block.find('.tabs');
      const tabsHTML = this.state.data.reduce((html, tab) => {
        return (html += `<label class="tab">${tab.title}<input type="radio" value="${tab.id}" name="payment-type" /></label> `);
      }, '');
      tabsBlock.html(tabsHTML);

      const tabs = tabsBlock.find('.tab input');
      tabs.eq(0).prop('checked', true);
      tabs.on('change', (e) => {
        this.state.activeTab = +$(e.currentTarget).val();
      });
      this.state.activeTab = +this.state.data[0].id;
    } catch (e) {
      console.error(e);
    }
  },
  renderSlides() {
    const renderButton = (text, type) => {
      const isMortgage = type === 'mortgage' && text === 'подробнее';
      const classes = isMortgage ? ' -brd' : '';
      const popupType = isMortgage ? 'mortgage' : 'callme';
      if (text) return `<button class="btn ${classes}" data-type="${popupType}" >${text}</button>`;
      return '<div class="btn-line"></div>';
    };
    const renderConditions = (list) => {
      if (!list.length) return '';
      if (list.length === 1) {
        return `<div class="mortgage-card__text">${list[0]}</div>`;
      }
      return `
        <ul>
          ${list.reduce((html, opt) => (html += `<li><span></span>${opt}</li>`), '')}
        </ul>`;
    };
    const wrapper = this.block.find('.swiper-wrapper');
    const src = this.state.data.find((d) => d.id == this.state.activeTab);
    const slides = src?.options ?? [];
    const slidesHTML = slides.reduce((html, slide) => {
      return (html += `
            <div class="swiper-slide">
              <div class="mortgage-card mortgage-tab">
                <div class="mortgage-card__wrapper">
                  <div class="mortgage-card__top">
                    <div class="mortgage-card__topWrap">
                      <div class="mortgage-card__imgWrap">
                        <img src="${slide.src}" alt="${slide.title}" />
                        <div class="bank-name">${slide.bank_name}</div>
                      </div>
                    </div>
                  <div class="mortgage-card__program">${slide.program}</div>
                  </div>
                <div class="mortgage-card__title">${slide.title}</div>
                ${renderConditions(slide.conditions)}
                </div>
                ${renderButton(slide.btnText, src.name)}
              </div>
            </div>
            `);
    }, '');
    wrapper.html(slidesHTML);
  },
};

const Overview = {
  block: $('.overview__wrap'),
  init: function () {
    if (!this.block.length) return;
    const planW = this.block.find('.overview__plan').width();
    this.block.scrollLeft(planW * 0.3);
  },
};

export default new Main();
